/* unplugin-vue-components disabled */import { render } from "./edit.vue?vue&type=template&id=4deacd8c&scoped=true&ts=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"

import "./edit.vue?vue&type=style&index=0&id=4deacd8c&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4deacd8c"]])

export default __exports__